/* Header: keeps --header-top / --header-bottom / --header-height current for the parts that sit under it
   (LMB.trackHeader in assets/theme.js, measuring the bar and the chips row together), and keeps chips in view:
   - the current collection's chip (LMB.showCurrentChip, defined inline in sections/header.liquid so it first runs
     before the first paint): again once the fonts have loaded, since the chips' widths change, and after a theme
     editor re-render;
   - a chip reached with Tab, focus ring included (browsers usually scroll the row themselves; this covers the
     ones that don't), and a Chip block selected in the theme editor.
   Both set the row's scrollLeft only: scrollIntoView could move the page too. */
if (!customElements.get('lmb-header')) {
  customElements.define(
    'lmb-header',
    class LmbHeader extends HTMLElement {
      constructor() {
        super();
        // Bound once and removed on disconnect: the theme editor can move the section (disconnect, then connect
        // again), and a second Space listener would open the search and close it again on one key press.
        this.onKeydown = this.onKeydown.bind(this);
        this.onChipFocus = this.onChipFocus.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        this.stopTracking = LMB.trackHeader(this, { sticky: this.dataset.sticky === 'always' });
        this.addEventListener('keydown', this.onKeydown);

        this.list = this.querySelector('.hchips__list');
        if (!this.list) return;
        this.list.addEventListener('focusin', this.onChipFocus);
        if (window.Shopify && Shopify.designMode) document.addEventListener('shopify:block:select', this.onBlockSelect);
        if (typeof LMB.showCurrentChip !== 'function') return;
        LMB.showCurrentChip(this);
        if (document.fonts) document.fonts.ready.then(() => this.isConnected && LMB.showCurrentChip(this));
      }

      disconnectedCallback() {
        // The theme editor replaces the section on every change: the old element stops writing the variables.
        if (this.stopTracking) this.stopTracking();
        this.removeEventListener('keydown', this.onKeydown);
        if (this.list) this.list.removeEventListener('focusin', this.onChipFocus);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      // The search opener is a link with role="button" (it still works without scripts): Space opens it too.
      onKeydown(event) {
        if (event.key !== ' ' || !event.target.matches('a[role="button"][data-overlay-open]')) return;
        event.preventDefault();
        event.target.click();
      }

      onChipFocus(event) {
        this.revealChip(event.target.closest('.hchips__link'));
      }

      onBlockSelect(event) {
        if (this.contains(event.target)) this.revealChip(event.target.querySelector('.hchips__link'));
      }

      revealChip(link) {
        const { list } = this;
        if (!link || list.scrollWidth <= list.clientWidth) return;
        const pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
        const box = list.getBoundingClientRect();
        const rect = link.getBoundingClientRect();
        if (rect.left < box.left + pad) list.scrollLeft -= box.left + pad - rect.left;
        else if (rect.right > box.right - pad) list.scrollLeft += rect.right - (box.right - pad);
      }
    }
  );
}
